import { Link, useLocation } from "react-router-dom";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面没找到 - 99看料",
    description: "你访问的页面可能已经调整或暂时不存在，回到首页继续看看大家在讨论什么。",
    path: location.pathname,
  });

  return (
    <div className="mx-auto flex w-full max-w-container flex-col items-center justify-center px-4 md:px-6 py-24 md:py-32 text-center">
      <span className="font-heading text-7xl md:text-9xl font-black text-background-300 select-none">404</span>
      <h1 className="mt-6 font-heading text-2xl md:text-3xl font-bold text-foreground-950">这条线索还没被写下来</h1>
      <p className="mt-3 max-w-md text-sm md:text-base leading-relaxed text-foreground-600">
        你访问的页面可能已经调整，或者暂时还不存在。不如先回首页，看看大家最近在讨论什么。
      </p>
      <p className="mt-2 font-label text-xs text-foreground-400">{location.pathname}</p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-line text-base" aria-hidden="true" />
        返回首页
      </Link>
    </div>
  );
}